import { render, staticRenderFns } from "./公示公告详情.vue?vue&type=template&id=a503cec2&scoped=true"
import script from "./公示公告详情.vue?vue&type=script&lang=js"
export * from "./公示公告详情.vue?vue&type=script&lang=js"
import style0 from "./公示公告详情.vue?vue&type=style&index=0&id=a503cec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503cec2",
  null
  
)

export default component.exports